export const LOADING_VIEW_STATE = "LOADING_VIEW_STATE";
export const VIEW_ERROR = "VIEW_ERROR";
export const SET_VIEW_STATE = "SET_VIEW_STATE";
export const ADD_VIEW_STATE = "ADD_VIEW_STATE";
export const UPDATE_VIEW_STATE = "UPDATE_VIEW_STATE";
export const DELETE_VIEW_STATE = "DELETE_VIEW_STATE";
export const IS_PERSONAL_INFO_VALIDATED = "IS_PERSONAL_INFO_VALIDATED";
export const UPDATE_CURRENT_APP_STATE = "UPDATE_CURRENT_APP_STATE";
export const SAVE_PERSONAL_DETAILS = "SAVE_PERSONAL_DETAILS";
export const GENERATE_OTP = "GENERATE_OTP";
export const VALIDATE_OTP = "VALIDATE_OTP";
export const CLEAR_OTP_RESPONSE = "CLEAR_OTP_RESPONSE";
export const GET_CARD_DETAILS = "GET_CARD_DETAILS";
export const GET_MASTER_DATA = "GET_MASTER_DATA";
export const GET_CITY_DATA = "GET_CITY_DATA";
export const GET_BANK_LIST_DATA = "GET_BANK_LIST_DATA";
export const GET_IFSC_CODE_DATA = "GET_IFSC_CODE_DATA";
export const GET_PAY_LINK_SERVICE_DATA = "GET_PAY_LINK_SERVICE_DATA";
export const VALIDATE_OTP_CREATE_SSL = "VALIDATE_OTP_CREATE_SSL";
export const SAVE_CKYC_DATA = "SAVE_CKYC_DATA";
export const SAVE_SSL_VAL_ERROR = "SAVE_SSL_VAL_ERROR";
export const SAVE_SSL_DATA_TO_STORE = "SAVE_SSL_DATA_TO_DATA";
export const SAVE_VAL_ERROR = "SAVE_VAL_ERROR";
export const SPLASH_VAL_TIMER = "SPLASH_VAL_TIMER";
export const SET_APP_CONTENT = "SET_APP_CONTENT";
export const SET_SUBMIT_SUCCESS = "SET_SUBMIT_SUCCESS";
export const UPDATE_STATE_AFTER_API_RES = "UPDATE_STATE_AFTER_API_RES";
export const SET_OCC_CONTENT = "SET_OCC_CONTENT";
export const SET_CND_CONTENT = "SET_CND_CONTENT";
export const RESET_BUTTON_PROGRESS = "RESET_BUTTON_PROGRESS";
export const SET_ERR_CONTENT = "SET_ERR_CONTENT";
export const SAVE_DIGILOCKER_DATA = "SAVE_DIGILOCKER_DATA";
export const SAVE_RESIADD_FLAGS = "SAVE_RESIADD_FLAGS";
export const SAVE_INGESTION2_RESPONSE = "SAVE_INGESTION2_RESPONSE";
export const SAVE_MULTURL_DATA = "SAVE_MULTURL_DATA";
export const APP_NAVIGATE_TO = "APP_NAVIGATE_TO";
export const SET_SELECTED_CARD_DETAILS = "SET_SELECTED_CARD_DETAILS";
export const CLEAR_USER_DATA = "CLEAR_USER_DATA";
export const SET_TAKE_PHOTO_ERROR = 'SET_TAKE_PHOTO_ERROR';
export const RESET_TAKE_PHOTO_ERROR = 'RESET_TAKE_PHOTO_ERROR';
export const SET_PHOTO_MATCH_LOADING = 'SET_PHOTO_MATCH_LOADING';
export const SHOW_LOADER_FOR_PENY = "SHOW_LOADER_FOR_PENY";
export const SAVE_STATUS_CODE = "SAVE_STATUS_CODE";
export const SET_PAN_UPLOAD_ERROR = 'SET_PAN_UPLOAD_ERROR';
export const RESET_PAN_UPLOAD_ERROR = 'RESET_PAN_UPLOAD_ERROR';
export const SET_PAN_UPLOADING_IN_PROGRESS = 'SET_PAN_UPLOADING_IN_PROGRESS';
export const ACCOUNT_VALIDATION = "ACCOUNT_VALIDATION";
export const SET_PREFERENCES = "SET_PREFERENCES";
export const GET_PREFERENCES = "GET_PREFERENCES";
export const IS_ACCOUNT_VALIDATION_FAILED = "IS_ACCOUNT_VALIDATION_FAILED";
export const IS_PAYBACK_FAILED = "IS_PAYBACK_FAILED";
export const DEBIT_RETRY_COUNT = "DEBIT_RETRY_COUNT";
export const CREDIT_RETRY_COUNT = "CREDIT_RETRY_COUNT";
export const GENERIC_ERROR = "GENERIC_ERROR";
export const SET_BOOT_APP_ERROR = "SET_BOOT_APP_ERROR";
export const LOADING_APP_STATE = "LOADING_APP_STATE";
export const APP_BOOT_STATUS = "APP_BOOT_STATUS";
export const SET_WEBCAM_STATUS = 'SET_WEBCAM_STATUS';
export const LOCAL_CONTENT_SET = "LOCAL_CONTENT_SET";
export const LOCAL_MASTER_SET = "LOCAL_MASTER_SET";
export const LOCAL_BANK_SET = "LOCAL_BANK_SET";
export const LOCAL_CITY_SET = "LOCAL_CITY_SET";
export const SET_WIP_STATUS = 'SET_WIP_STATUS';
export const RESET_APP = 'RESET_APP';
export const CLEAR_SSL_DATA = 'CLEAR_SSL_DATA';
export const LOCAL_CITY_SET_BY_PIN = "LOCAL_CITY_SET_BY_PIN";
export const GET_CITY_DATA_BY_PIN = "GET_CITY_DATA_BY_PIN";
export const SAVE_VAL_ERROR_MS = "SAVE_VAL_ERROR_MS";
export const SAVE_VISION_DATA = "SAVE_VISION_DATA";
export const GET_CREATE_ORDER_DATA = "GET_CREATE_ORDER_DATA";
export const SAVE_PARTNER_DATA = "SAVE_PARTNER_DATA";
export const CAD_ADDRESS_CONFIRMED = "CAD_ADDRESS_CONFIRMED";
export const PARTNER_INGESTION_DATA = "PARTNER_INGESTION_DATA";
export const UPDATE_CURRENT_PARTNER_STATE = "UPDATE_CURRENT_PARTNER_STATE";
export const SAVE_VKYCURL_DATA = "SAVE_VKYCURL_DATA";
export const SAVE_VKYCOPT_FLAG = "SAVE_VKYCOPT_FLAG";
export const SAVE_VKYC_STATUS = "SAVE_VKYC_STATUS";
export const SAVE_VKYC_OFF_HRS = "SAVE_VKYC_OFF_HRS";
export const SAVE_NW_DATA = "SAVE_NW_DATA";
export const SAVE_SELECTED_NW_DATA = "SAVE_SELECTED_NW_DATA";
export const RESET_NW_DATA = "RESET_NW_DATA";
export const SAVE_NETWORK_CARDTYPE = "SAVE_NETWORK_CARDTYPE";
export const LOCAL_NETWORK_MASTER_SET = "LOCAL_NETWORK_MASTER_SET";
export const SAVE_TELCO_OTP_GEN = "SAVE_TELCO_OTP_GEN";
export const CLEAR_TELCO_OTP_RESPONSE = "CLEAR_TELCO_OTP_RESPONSE";
export const SET_SURROGATE_CONTENT = "SET_SURROGATE_CONTENT";
export const SAVE_FINARKIN_URL = "SAVE_FINARKIN_URL";
export const SAVE_FINARKEIN_STATUS = "SAVE_FINARKEIN_STATUS";
export const SAVE_SURROGATE_DATA = "SAVE_SURROGATE_DATA";
export const SAVE_DOWNSELL_CARDS = "SAVE_DOWNSELL_CARDS";
export const SAVE_FINAL_CREDIT_LIMIT = "SAVE_FINAL_CREDIT_LIMIT";
export const SAVE_SELECTED_SURROGATE = "SAVE_SELECTED_SURROGATE";
export const SAVE_RESPONSE_SURGST_PERFIOS_URL = "SAVE_RESPONSE_SURGST_PERFIOS_URL";
export const SAVE_PERFIOS_REDIRECT_STATUS = "SAVE_PERFIOS_REDIRECT_STATUS";
export const SAVE_EPFO_OTP_GEN_RESPONSE = "SAVE_EPFO_OTP_GEN_RESPONSE";
export const UPDATE_SURROGATE_LIST = "UPDATE_SURROGATE_LIST";
export const SET_EPFO_OTP_GEN_ERROR_CODE = "SET_EPFO_OTP_GEN_ERROR_CODE";
export const SAVE_BLAZESTP_ELIGIBLE = "SAVE_BLAZESTP_ELIGIBLE";
export const SAVE_HSTOKEN = "SAVE_HSTOKEN";
